import { Link } from 'react-router-dom';
import { Compass } from 'lucide-react';

import { Button } from '@/components/ui/button';

export function NotFoundPage() {
  return (
    <div className="mx-auto flex max-w-xl flex-col items-center gap-4 px-4 py-16 text-center">
      <div className="bg-brand-600 shadow-card flex h-12 w-12 items-center justify-center rounded-2xl text-white">
        <Compass size={20} />
      </div>
      <h1 className="text-3xl font-semibold text-slate-900">Page not found</h1>
      <p className="text-slate-600">
        The trail you followed ends here. Navigate back to the Shift Book shell.
      </p>
      <Button asChild>
        <Link to="/">Back to Shift Book</Link>
      </Button>
    </div>
  );
}
